/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoleDto } from '../models/RoleDto';
import type { RolePermissionDto } from '../models/RolePermissionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoleControllerService {
    /**
     * @param uuid
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roles/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: RoleDto,
    ): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/roles/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/roles/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<RoleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roles',
        });
    }
    /**
     * @param requestBody
     * @returns RoleDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: RoleDto,
    ): CancelablePromise<RoleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/roles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns RolePermissionDto OK
     * @throws ApiError
     */
    public static getRolePermissions(
        uuid: string,
    ): CancelablePromise<Array<RolePermissionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roles/{uuid}/permissions',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns RolePermissionDto OK
     * @throws ApiError
     */
    public static updateRolePermissions(
        uuid: string,
        requestBody: Array<string>,
    ): CancelablePromise<Array<RolePermissionDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/roles/{uuid}/permissions',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
